/**
 * Ray's Loyalty — Redemption records list (standalone page + personal center embed).
 */
(function () {
  'use strict';

  var TAB_DEFS = [
    { id: 'ALL', labelKey: 'tabAll' },
    { id: 'POINTS_REWARD', labelKey: 'tabRewards' },
    { id: 'MONTHLY_REWARD', labelKey: 'tabMonthly' },
    { id: 'BIRTHDAY_GIFT', labelKey: 'tabBirthday' },
    { id: 'OTHER', labelKey: 'tabOther' }
  ];

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escAttr(s) {
    return esc(s).replace(/'/g, '&#39;');
  }

  /** Locale strings from Liquid may already contain HTML entities; normalize before esc(). */
  function labelText(s) {
    var raw = String(s == null ? '' : s)
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'");
    return esc(raw);
  }

  function formatPointsMsg(template, points) {
    var n = String(points);
    var s = String(template || '').split('[points]').join(n);
    var open = '{' + '{';
    var close = '}' + '}';
    try {
      s = s.replace(new RegExp(open + '\\s*points\\s*' + close, 'g'), n);
    } catch (e) {}
    return s;
  }

  function mount(root, options) {
    options = options || {};
    if (!root || (root.dataset.rlRecordsMounted === '1' && !options.force)) return;
    var I = options.labels || {};
    var loadingEl = options.loadingEl || null;
    var syncTabUrl = options.syncTabUrl !== false;
    var defaultImage = root.getAttribute('data-default-image') || '';
    var shopLocale = root.getAttribute('data-locale') || document.documentElement.lang || 'en';
    var pageSize = parseInt(root.getAttribute('data-page-size') || '12', 10);
    if (!pageSize || pageSize < 1) pageSize = 12;

    var tabsEl = root.querySelector('[data-rl-records-tabs]');
    var panelEl = root.querySelector('[data-rl-records-panel]');
    var gridEl = root.querySelector('[data-rl-records-grid]');
    var moreEl = root.querySelector('[data-rl-records-more]');
    var emptyEl = root.querySelector('[data-rl-records-empty]');
    var toastEl = root.querySelector('[data-rl-records-toast]');

    var TAB_IDS = TAB_DEFS.map(function (t) {
      return t.id;
    });

    var allItems = [];
    var activeTab = 'ALL';
    var visibleCount = pageSize;
    var rewardImageByHandle = Object.create(null);

    function formatDate(iso) {
      if (!iso) return '';
      var d = new Date(iso);
      if (isNaN(d.getTime())) return String(iso);
      try {
        return d.toLocaleString(shopLocale, {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return d.toLocaleString('en', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    }

    function discountLine(d, rewardKind) {
      if (String(rewardKind || '').toLowerCase() === 'free_product_discount') {
        return labelText(I.freeProduct || 'Free product');
      }
      if (!d || !d.kind) return '';
      if (d.kind === 'percent' && d.value != null) return esc(d.value) + '% off';
      if (d.kind === 'fixed' && d.amountCents != null) {
        var major = (d.amountCents / 100).toFixed(2);
        return esc(d.currencyCode || '') + ' ' + major + ' off';
      }
      if (d.kind === 'free_shipping') return labelText(I.freeShipping || 'Free shipping');
      if (d.kind === 'gift_card') return 'Gift card';
      return '';
    }

    function reasonLabel(reason) {
      var r = String(reason || '').toLowerCase();
      if (r === 'order_paid') return I.reasonOrder || 'Order';
      if (r === 'redeem') return I.reasonRedeem || I.redemption || 'Redemption';
      if (r === 'monthly_tier_grant') return I.reasonMonthly || 'Monthly VIP';
      if (r === 'birthday_bonus') return I.reasonBirthday || 'Birthday';
      if (r === 'registration_bonus') return I.reasonRegistration || 'Registration';
      if (r === 'visit') return I.reasonVisit || 'Visit';
      if (r.indexOf('referral') !== -1) return I.reasonReferral || 'Referral';
      if (r === 'refund_clawback') return I.reasonRefund || 'Refund';
      if (r.indexOf('rollback') !== -1) return I.reasonRollback || 'Rollback';
      if (r === 'admin_grant') return I.reasonAdmin || 'Admin';
      return I.reasonOther || 'Other';
    }

    function ledgerCategory(reason) {
      var r = String(reason || '').toLowerCase();
      if (r === 'redeem' || r.indexOf('redeem') !== -1) return 'POINTS_REWARD';
      if (r === 'monthly_tier_grant') return 'MONTHLY_REWARD';
      if (r === 'birthday_bonus') return 'BIRTHDAY_GIFT';
      return 'OTHER';
    }

    function couponCategories(c) {
      if (c.source === 'redemption') return ['POINTS_REWARD'];
      if (c.source === 'monthly_vip') return ['MONTHLY_REWARD'];
      return ['OTHER'];
    }

    function isCouponActive(c) {
      var now = Date.now();
      var end = c.window && c.window.endsAt ? new Date(c.window.endsAt).getTime() : null;
      if (end != null && !isNaN(end) && end < now) return false;
      var st = String(c.status || '').toLowerCase();
      if (st && st !== 'issued' && st !== 'active') return false;
      var lim = c.usage && c.usage.limit;
      var used = c.usage && c.usage.used;
      if (lim != null && used != null && used >= lim) return false;
      return true;
    }

    function couponStatusBadge(c) {
      if (isCouponActive(c)) return '';
      var st = String(c.status || '').toLowerCase();
      if (st.indexOf('used') !== -1) return I.statusUsed || 'Used';
      return I.statusExpired || 'Expired';
    }

    function buildItems(couponsPayload, ledgerEntries, rewards) {
      var items = [];
      var personal = (couponsPayload && couponsPayload.personal) || [];

      (rewards || []).forEach(function (rw) {
        if (rw && rw.handle) rewardImageByHandle[rw.handle] = rw.imageUrl || '';
      });

      personal.forEach(function (c) {
        var img =
          (c.spendRuleHandle && rewardImageByHandle[c.spendRuleHandle]) || defaultImage || '';
        items.push({
          id: 'c:' + c.id,
          categories: couponCategories(c),
          sortAt: (c.window && c.window.startsAt) || '',
          kind: 'coupon',
          title: c.title || I.redemption || 'Redemption',
          code: c.code || null,
          imageUrl: img,
          discountLine: discountLine(c.discount, c.rewardKind),
          description: c.description || '',
          dateLabel: formatDate(c.window && c.window.startsAt),
          active: isCouponActive(c),
          statusBadge: couponStatusBadge(c),
          pointsDelta: null,
          rewardKind: c.rewardKind || '',
          freeProductCart: c.freeProductCart || null
        });
      });

      (ledgerEntries || []).forEach(function (e) {
        var cat = ledgerCategory(e.reason);
        var delta = Number(e.delta) || 0;
        var isRedeem = cat === 'POINTS_REWARD';

        if (isRedeem && delta >= 0) return;

        if (isRedeem) {
          var day = e.createdAt ? String(e.createdAt).slice(0, 10) : '';
          var hasCode = personal.some(function (c) {
            if (c.source !== 'redemption' || !c.code) return false;
            var t = (c.window && c.window.startsAt) || '';
            return day && t && String(t).slice(0, 10) === day;
          });
          if (hasCode) return;
        }

        var title = isRedeem ? I.redemption || 'Redemption' : reasonLabel(e.reason);
        var desc = '';
        if (isRedeem && delta < 0) {
          desc = formatPointsMsg(I.pointsSpent, Math.abs(delta));
        } else if (delta > 0) {
          desc = formatPointsMsg(I.pointsEarned, delta);
        } else if (delta < 0) {
          desc = formatPointsMsg(I.pointsSpent, Math.abs(delta));
        }

        items.push({
          id: 'l:' + (e.id || e.createdAt),
          categories: [cat],
          sortAt: e.createdAt || '',
          kind: isRedeem ? 'redeem' : 'ledger',
          title: title,
          code: null,
          imageUrl: isRedeem ? defaultImage : '',
          discountLine: isRedeem ? labelText(I.storeCredit || 'Store credit') : '',
          description: desc,
          dateLabel: formatDate(e.createdAt),
          active: true,
          statusBadge: '',
          pointsDelta: delta
        });
      });

      items.sort(function (a, b) {
        var ta = new Date(a.sortAt).getTime();
        var tb = new Date(b.sortAt).getTime();
        if (isNaN(ta) && isNaN(tb)) return 0;
        if (isNaN(ta)) return 1;
        if (isNaN(tb)) return -1;
        return tb - ta;
      });

      return items;
    }

    function itemsForTab(tab) {
      return allItems.filter(function (it) {
        return tab === 'ALL' || it.categories.indexOf(tab) !== -1;
      });
    }

    function renderCard(item) {
      var inactive = !item.active || item.statusBadge;
      var isActivity = item.kind === 'ledger' && !item.imageUrl && !item.code;
      var html =
        '<li class="rays-loyalty-records__card' +
        (inactive ? ' is-inactive' : '') +
        (isActivity ? ' rays-loyalty-records__card--activity' : '') +
        '">';
      html += '<div class="rays-loyalty-records__card-top">';
      if (item.imageUrl) {
        html +=
          '<img class="rays-loyalty-records__card-img" src="' +
          escAttr(item.imageUrl) +
          '" alt="" loading="lazy" decoding="async" />';
      } else {
        html += '<div class="rays-loyalty-records__card-img rays-loyalty-records__card-img--empty" aria-hidden="true"></div>';
      }
      html += '<div class="rays-loyalty-records__card-code">';
      if (item.code) {
        html += '<p class="rays-loyalty-records__code-line">' + labelText(I.codeLabel || 'Code') + ' <span>' + esc(item.code) + '</span></p>';
        var showFreeProductBtn =
          item.active &&
          String(item.rewardKind || '').toLowerCase() === 'free_product_discount' &&
          item.freeProductCart &&
          (item.freeProductCart.variantId || item.freeProductCart.productPath);
        if (showFreeProductBtn) {
          html +=
            '<button type="button" class="rays-loyalty-records__add-cart" data-rl-records-add-cart="' +
            escAttr(item.code) +
            '" data-rl-records-cart="' +
            escAttr(JSON.stringify(item.freeProductCart)) +
            '">' +
            labelText(I.addFreeProduct || 'Add to cart & apply code') +
            '</button>';
        } else if (item.active) {
          html +=
            '<button type="button" class="rays-loyalty-records__copy" data-rl-records-copy="' +
            escAttr(item.code) +
            '">' +
            labelText(I.copy || 'Copy') +
            '</button>';
        } else if (item.statusBadge) {
          html += '<span class="rays-loyalty-records__badge">' + esc(item.statusBadge) + '</span>';
        }
      } else if (item.kind === 'redeem') {
        html += '<p class="rays-loyalty-records__code-line rays-loyalty-records__code-line--muted">' + labelText(I.storeCredit || 'Store credit') + '</p>';
      }
      html += '</div></div>';
      html += '<div class="rays-loyalty-records__card-meta">';
      html += '<p class="rays-loyalty-records__card-title">' + esc(item.title) + '</p>';
      if (item.discountLine) html += '<p class="rays-loyalty-records__card-discount">' + item.discountLine + '</p>';
      if (item.description) html += '<p class="rays-loyalty-records__card-desc">' + esc(item.description) + '</p>';
      if (item.dateLabel) {
        html +=
          '<p class="rays-loyalty-records__card-time"><span aria-hidden="true"></span>' +
          labelText(I.effective || 'Effective') +
          ' ' +
          esc(item.dateLabel) +
          '</p>';
      }
      html += '</div></li>';
      return html;
    }

    function showToast(msg) {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.hidden = false;
      window.clearTimeout(showToast._t);
      showToast._t = window.setTimeout(function () {
        toastEl.hidden = true;
      }, 1600);
    }

    function bindCopyButtons() {
      if (!gridEl) return;
      gridEl.querySelectorAll('[data-rl-records-copy]').forEach(function (btn) {
        if (btn.dataset.rlCopyBound) return;
        btn.dataset.rlCopyBound = '1';
        btn.addEventListener('click', function () {
          var code = btn.getAttribute('data-rl-records-copy') || '';
          var done = function () {
            showToast(I.copied || 'Copied');
          };
          if (window.RaysLoyalty && typeof window.RaysLoyalty.copyToClipboard === 'function') {
            window.RaysLoyalty.copyToClipboard(code).then(done).catch(done);
          } else if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done).catch(done);
          }
        });
      });
    }

    function bindAddCartButtons() {
      if (!gridEl) return;
      gridEl.querySelectorAll('[data-rl-records-add-cart]').forEach(function (btn) {
        if (btn.dataset.rlAddCartBound) return;
        btn.dataset.rlAddCartBound = '1';
        btn.addEventListener('click', function () {
          var code = btn.getAttribute('data-rl-records-add-cart') || '';
          var cartRaw = btn.getAttribute('data-rl-records-cart') || '';
          var cart = null;
          try {
            cart = cartRaw ? JSON.parse(cartRaw) : null;
          } catch (e) {
            cart = null;
          }
          if (!code || !window.RaysLoyalty || typeof window.RaysLoyalty.applyFreeProductDiscountToCart !== 'function') {
            return;
          }
          btn.disabled = true;
          btn.classList.add('is-loading');
          window.RaysLoyalty.applyFreeProductDiscountToCart(code, cart).catch(function () {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart'));
          });
        });
      });
    }

    function renderList() {
      var list = itemsForTab(activeTab);
      if (!list.length) {
        if (panelEl) panelEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        if (moreEl) moreEl.hidden = true;
        if (gridEl) gridEl.innerHTML = '';
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (panelEl) panelEl.hidden = false;
      var slice = list.slice(0, visibleCount);
      if (gridEl) {
        gridEl.innerHTML = slice.map(renderCard).join('');
        bindCopyButtons();
        bindAddCartButtons();
      }
      if (moreEl) {
        if (list.length > visibleCount) {
          moreEl.hidden = false;
          moreEl.textContent = I.loadMore || 'Load more';
        } else {
          moreEl.hidden = true;
        }
      }
    }

    function setTab(tab) {
      activeTab = TAB_IDS.indexOf(tab) !== -1 ? tab : 'ALL';
      visibleCount = pageSize;
      if (tabsEl) {
        tabsEl.querySelectorAll('[data-rl-records-tab]').forEach(function (btn) {
          var on = btn.getAttribute('data-rl-records-tab') === activeTab;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      if (syncTabUrl) {
        try {
          var url = new URL(window.location.href);
          if (activeTab === 'ALL') url.searchParams.delete('tab');
          else url.searchParams.set('tab', activeTab);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
      renderList();
    }

    function buildTabs() {
      if (!tabsEl) return;
      tabsEl.innerHTML = TAB_DEFS.map(function (t) {
        return (
          '<button type="button" class="rays-loyalty-records__tab" data-rl-records-tab="' +
          escAttr(t.id) +
          '" role="tab" aria-selected="false">' +
          labelText(I[t.labelKey] || t.id) +
          '</button>'
        );
      }).join('');
      tabsEl.querySelectorAll('[data-rl-records-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setTab(btn.getAttribute('data-rl-records-tab'));
        });
      });
      if (moreEl) {
        moreEl.addEventListener('click', function () {
          visibleCount += pageSize;
          renderList();
        });
      }
    }

    function showLoadError() {
      if (loadingEl) {
        loadingEl.textContent = I.err || 'Something went wrong';
        loadingEl.classList.add('rays-loyalty__error');
        loadingEl.hidden = false;
      }
    }

    function loadRecords() {
      var initialTab = 'ALL';
      if (syncTabUrl) {
        try {
          initialTab = (new URL(window.location.href).searchParams.get('tab') || 'ALL').toUpperCase();
        } catch (e) {
          initialTab = 'ALL';
        }
        if (TAB_IDS.indexOf(initialTab) === -1) initialTab = 'ALL';
      }

      if (window.RaysLoyalty && window.RaysLoyalty.syncStorefrontTokenFromWebComponents) {
        try {
          window.RaysLoyalty.syncStorefrontTokenFromWebComponents();
        } catch (e) {}
      }

      Promise.all([
        window.RaysLoyalty.getCoupons().catch(function (err) {
          console.warn('[rays-loyalty] records getCoupons', err);
          return { personal: [], universal: [] };
        }),
        window.RaysLoyalty.getLedger().catch(function (err) {
          console.warn('[rays-loyalty] records getLedger', err);
          return { entries: [] };
        }),
        window.RaysLoyalty.getRewards().catch(function (err) {
          console.warn('[rays-loyalty] records getRewards', err);
          return { rewards: [] };
        })
      ])
        .then(function (res) {
          allItems = buildItems(res[0], (res[1] && res[1].entries) || [], (res[2] && res[2].rewards) || []);
          if (loadingEl) loadingEl.hidden = true;
          root.hidden = false;
          setTab(initialTab);
        })
        .catch(function (err) {
          console.warn('[rays-loyalty] records load', err);
          showLoadError();
        });
    }

    function waitForRaysLoyalty(next, onTimeout, maxMs) {
      maxMs = maxMs != null ? maxMs : 8000;
      var started = Date.now();
      function ready() {
        return (
          window.RaysLoyalty &&
          typeof window.RaysLoyalty.getCoupons === 'function' &&
          typeof window.RaysLoyalty.getLedger === 'function'
        );
      }
      function tick() {
        if (ready()) {
          next();
          return;
        }
        if (Date.now() - started > maxMs) {
          if (onTimeout) onTimeout();
          return;
        }
        window.setTimeout(tick, 40);
      }
      if (ready()) {
        next();
        return;
      }
      tick();
    }

    if (root.dataset.rlRecordsMounted === '1' && options.force) {
      waitForRaysLoyalty(loadRecords, showLoadError);
      return;
    }

    root.dataset.rlRecordsMounted = '1';
    buildTabs();
    waitForRaysLoyalty(loadRecords, showLoadError);
  }

  window.RlRecords = { mount: mount };
})();
